/* eslint semi: 1 */

export default {
  name: 'player-setup-unit',
  props: {
    unit: {
      type: String,
      default: () => 'in'
    }
  },
  data () {
    return {
      model: {
        unit: 'in'
      },
      unitOptions: [{
        label: 'in',
        value: 'in'
      },
      {
        label: 'mm',
        value: 'mm'
      }]
    };
  },
  watch: {
    unit (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDefaultUnit();
      }
    }
  },
  methods: {
    setDefaultUnit () {
      this.model.unit = this.unit;
      this.$emit('change', this.model.unit);
    }
  },
  mounted () {
    this.setDefaultUnit();
  }
};
